export interface ITableConfig {
  actionList?: ITableActions[];
  columnStyles?: IColumnStyle[];
  emptyListMessage: string;
}

export class TableConfig implements ITableConfig {
  actionList?: ITableActions[] = [];
  columnStyles?: IColumnStyle[] = [];
  emptyListMessage: string = 'No data';

  constructor(configOverride?: Partial<ITableConfig>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface ITableActions {
  order: number;
  label: string;
  path: string;
  icon: string;
  event: string;
  action: string;
}

export class TableActions implements ITableActions {
  order: number = 0;
  label: string = '';
  path: string = '/';
  icon: string = '';
  event: string = '';
  action: string = '';

  constructor(configOverride?: Partial<ITableActions>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface ITableColumns {
  columnIndex: number;
  columnId: string;
  columnName: string;
}

export interface IColumnStyle {
  columnId: string;
  style: any;
  proc?: any;
}

export enum SortDirection {
  asc = 'ASC',
  desc = 'DESC',
}
